import {
  getRegionDataByCityUrl,
  getRegionByCoordinatesUrl,
  getRegionNamesUrl,
  getRegionPopulationFactorUrl,
  getPincodeRankingByTgUrl,
} from "../urls/RegionURL";
import {
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";

export async function getRegionDataByCityId(cityId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getRegionDataByCityUrl.replace(":cityId", cityId);
  return sendGetRequest(url, {}, true, headerParams);
}

export async function getRegionNamesList() {
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendGetRequest(getRegionNamesUrl, {}, true, headerParams);
}

export async function getRegionByCoordinatesFn(latitude, longitude) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    latLongStr: `${latitude},${longitude}`,
  };

  return sendGetRequest(getRegionByCoordinatesUrl, params, true, headerParams);
}

export async function getRegionPopulationFactorFn(cityId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getRegionPopulationFactorUrl.replace(":cityId", cityId);
  return sendGetRequest(url, {}, true, headerParams);
}

export async function getPincodeRankingByTgFn(
  pincodePopulationBeans = [],
  tgAttrNames = ""
) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const body = {
    pincodePopulationBeans, // pincode beans with population and pincode
    tgNames: tgAttrNames, // selected tg names : comma separated strings
  };

  // it is a POST request as we need to pass the body
  return sendCreateOrUpdateRequest(
    getPincodeRankingByTgUrl,
    body,
    true,
    "POST",
    headerParams
  );
}
